<template>
  <button
    class="flex h-10 px-6 justify-center items-center gap-1 flex-1 rounded-3xl disabled:h-10 disabled:py-2u disabled:px-6 disabled:gap-1 disabled:cursor-not-allowed disabled:text-text-disabled aria-busy:h-10 aria-busy:py-2u aria-busy:px-6"
    :class="{
      'bg-fill-brand-secondary hover:border-button_shadow_light hover:bg-fill-brand-hover active:border-border-brand active:bg-fill-brand-pressed disabled:bg-fill-disabled aria-busy:bg-fill-brand-pressed':
        priority === 'normal',
      'bg-fill-warning-secondary hover:border-border-button-shadow-light hover:bg-fill-warning-secondary  active:border-border-warning active:bg-fill-warning-secondary disabled:bg-fill-disabled aria-busy:bg-fill-warning':
        priority === 'incoming',

      'bg-fill-critical-secondary hover:border-border-button-shadow-light hover:bg-fill-critical-secondary active:border-border-warning active:bg-fill-critical-secondary disabled:bg-fill-disabled aria-busy:bg-fill-critical':
        priority === 'urgent',

      'border-border-button-shadow-light bg-fill-brand hover:bg-fill_fill-brand-hover active:border-border-brand active:bg-fill-brand-pressed disabled:py-2u disabled:bg-fill-disabled aria-busy:bg-fill_fill-brand-pressed hover:h-10 hover:px-6 hover:py-1 hover:items-center hover:gap-1 hover:border-t active:h-10 active:py-2u active:px-6 active:items-center active:gap-1 active:border-t-2':
        variant === 'primary',

      'bg-fill-brand-secondary hover:border-border-button-shadow-light hover:bg-fill-brand-hover  active:border-border-brand active:bg-fill-brand-pressed  disabled:bg-fill-disabled disabled:cursor-not-allowed aria-busy:bg-fill-brand-pressed py-1.5':
        variant === 'subtle',
    }"
    :disabled="isLoading || disabled"
    @click="emit('click')"
  >
    <span v-if="isLoading" class="loading loading-spinner loading-xs" />
    <template v-else>
      <slot />
    </template>
  </button>
</template>
<script setup lang="ts">
import { CardPriority } from "./creation/contests";

const emit = defineEmits<{
  click: [];
}>();

const _props = defineProps<{
  variant?: "primary" | "subtle";
  disabled?: boolean;
  isLoading?: boolean;
  priority?: CardPriority;
}>();
</script>
